import { useUnit } from 'effector-react';
import { $isDesktop } from 'models/device-params-model';
import $$dropdowns from 'models/dropdowns';
import { $isGiftTrustPage, $pathname } from 'models/location';
import { $global } from 'models/store-global';
import { $modals } from 'models/store-modals';
import { useEffect } from 'react';

import ZendeskHelpService from 'services/ZendeskHelpService';

const listOfHiddenRoutes = ['/participants-info', '/payment'] as const;

const $isListedPage = $pathname.map((pathname) => listOfHiddenRoutes.some((route) => pathname.startsWith(route)));

const $isAddGiftModalOpened = $modals.map((state) => state.ADD_GIFT_ITEM_MODAL?.isOpened).map(Boolean);

// TODO: Move this logic to model
const useHelpHider = () => {
    const isAssessmentPage = useUnit($global.map((state) => Boolean(state.navigation?.assessmentPage)));
    const menuIsOpened = useUnit($$dropdowns.$opened.map((opened) => opened.includes('profileContextMenu')));

    const isDesktop = useUnit($isDesktop);
    const isOnListedPage = useUnit($isListedPage);
    const isAddGiftModalOpened = useUnit($isAddGiftModalOpened);
    const isGiftTrustPage = useUnit($isGiftTrustPage);

    const isMobileMenuOpened = menuIsOpened && !isDesktop;
    const mustBeHidden = isOnListedPage || isAssessmentPage || isMobileMenuOpened || isAddGiftModalOpened;

    useEffect(() => {
        if (mustBeHidden) {
            ZendeskHelpService.hideWidget();
        } else {
            ZendeskHelpService.showWidget();
            if (isGiftTrustPage && !isDesktop) {
                ZendeskHelpService.moveWidget({
                    mobile: {
                        horizontal: '80vw',
                        vertical: '0',
                    },
                });
            }
        }
    }, [mustBeHidden, isGiftTrustPage, isDesktop]);
};

export default useHelpHider;
